import React, { useContext, useState } from 'react';
import { Col, Row } from 'reactstrap';
import UserSettings from 'components/profile/UserSettings';
import UserProfile from 'components/profile/UserProfile';
import { UserSettingsContext } from 'contexts/UserSettingsContext';
import SpeicherfuchsProfile from 'apps/speicherfuchs/Profile';
import { APP_KEYS } from 'constants';

function Profile() {
    const { userSettings, userId } = useContext(UserSettingsContext);
    const speicherfuchs = userSettings.selected_app === APP_KEYS.SPEICHERFUCHS;
    const [openSection, setOpenSection] = useState(""); 
    
    return (
        <div className='content'>
            <Row>
                <Col md="6">
                    <UserProfile/>
                </Col>
                <Col md="6">
                    {speicherfuchs ? (
                        <SpeicherfuchsProfile
                            openSection={openSection}
                            setOpenSection={setOpenSection}
                        />
                    ) : (
                        <UserSettings />
                    )}
                </Col>
            </Row>
        </div>
    );
}
export default Profile;
